var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AffiliateLandingPage',{attrs:{"imageExt":"png","imageName":"corestream","routePath":"corestream","company":"Corestream"}})
}
var staticRenderFns = []

export { render, staticRenderFns }